import { Subject, Subscription } from 'rxjs';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { RequestVerifiedAction, UpdateOverallStatusAction } from '../actions';
import { greenId_MemberData, greenId_Model } from '../selectors';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AppState } from 'src/app/store/app.states';
import { commomState_SystemConfig_Config } from 'src/app/store/common/common.selectors';
import { ComponentBase } from 'src/app/views/component-base';

declare var greenidUI: any;
declare var greenidJQuery: any;
declare var greenidUiBehaviours: any;
declare var greenidConfig: any;
@Component({
  selector: 'docs-verification-dialog',
  styleUrls: ['./docs-verification-dialog.component.scss'],
  templateUrl: 'docs-verification-dialog.component.html',
})
export class GreenIdDocsVerificationDialog extends ComponentBase implements OnInit {
  verificationId: string = '';
  memberData$ = this.store.pipe(select(greenId_MemberData));
  tenantConfig$ = this.store.pipe(select(commomState_SystemConfig_Config));

  model$ = this.store.pipe(select(greenId_Model));
  subscription: Subscription | null = null;
  memberDataLoaded = false;
  pendingText = '';
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public store: Store<AppState>,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<GreenIdDocsVerificationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();

    this.verificationId = data.verificationId;

    this.pendingText =
      'One or more of your documents is pending approval from the Administrator. Please get in touch with the Contact Centre to have this reviewed';

    greenidJQuery('document').ready(() => {

      if (data) {
        if (data.verificationToken) {
          greenidUI.setup({
            environment: environment.greenIdEnv,
            frameId: 'greenid-div',
            errorCallback: (
              verificationToken: any,
              errorName: any,
              code: any,
              err: any
            ) => this.onError(verificationToken, errorName, code, err),
            sessionCompleteCallback: (
              verificationToken: any,
              overallState: any
            ) => this.onSessionComplete(verificationToken, overallState),
            sourceAttemptCallback: (
              verificationToken: any,
              sourceName: any,
              checkState: any,
              overallState: any
            ) =>
              this.onSourceAttempt(
                verificationToken,
                sourceName,
                checkState,
                overallState
              ),
            sessionCancelledCallback: (
              verificationToken: any,
              overallState: any
            ) => this.onSessionCancel(verificationToken, overallState),
            registerCallback: (verificationToken: any, userData: any) =>
              this.registerCallback(verificationToken, userData),
            submitCallback: (verificationToken: any, overallState: any) => {
              var tt = '';
            },
          });

          // this.displayInitialForm = false;
          greenidUI.show(
            'ifaa',
            environment.greenIdCode,
            data.verificationToken
          );
        }
      }

      greenidUiBehaviours.initiateTooltips();
      greenidConfig.setOverrides({ enable_save_and_complete_later: false });
    });
  }
  
  ngOnInit(): void {
    this.sub = this.tenantConfig$.subscribe(x => {
      if (x){
        if (x.email && x.phoneNumber) {
          this.pendingText =
            this.pendingText +
            ` at ${x.phoneNumber} or <a href='mailto:${x.email}'>${x.email}</a>`;
        }
      }
    })
  }

  unsubscribeMembeerData() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onConfirmClick(): void {
    this.subscription?.unsubscribe();
    this.dialogRef.close('ok');
  }

  onUpdateDataClick(): void {
    this.subscription?.unsubscribe();
    this.dialogRef.close();
    this.router.navigate([this.data.updateDataLink]);
  }

  onCancelClick(): void {
    this.subscription?.unsubscribe();
    this.dialogRef.close();
  }

  preSubmitValidationCallback(a: any) {
    return true;
  }  
  
  onSessionCancel(_verificationToken: any, _overallState: any) {
    //does nothing
  }
  
  registerCallback(verificationId: any, overallState: any) {
    this.verificationId = verificationId;
    this.store.dispatch(
      RequestVerifiedAction({
        account: this.data.accountId,
        verificationId: this.verificationId,
      })
    );
  }

  onError(verificationToken: any, errorName: any, code: any, err: any) {
    if (err.isFault) {
      let errMessage = err.faultData.faultString.toString() as string;
      errMessage = errMessage.replace('givenname', 'First Name');
      errMessage = errMessage.replace('surname', 'Surname');

      this.toastr.error(errMessage);
    }
    setTimeout(() => {
      var elem = (<any>document.getElementsByClassName('greenid-modal'))[0];
      elem.style.display = 'none';
      elem = (<any>(
        document.getElementsByClassName('greenid-modal-backdrop')
      ))[0];
      elem.style.display = 'none';
    }, 1500);
  }

  onSourceAttempt(
    verificationToken: any,
    sourceName: any,
    checkState: any,
    overallState: any
  ) {
    if (overallState.indexOf('VERIFIED') >= 0) {
      this.store.dispatch(
        RequestVerifiedAction({
          account: this.data.accountId,
          verificationId: this.verificationId,
        })
      );
      this.onCancelClick();
    }
  }

  onSessionComplete(verificationToken: any, overallState: any) {
    this.store.dispatch(UpdateOverallStatusAction({ status: overallState }));
  }
}
